module.exports = __webpack_public_path__ + "img/header-phone.71d64821.jpg";